/* 20250717: Callback.js
*.  this is now chagend for rr6 . need to check for params for redirect first
*.  If code and state are missing in the URL query params, 
*. it skips calling handleRedirectCallback() and just redirects the user to /dashboard.
*/

import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setProfile } from '../../actions/profile';
import { useLocation } from 'react-router-dom';

const Callback = () => {
  //const { handleRedirectCallback } = useAuth0();
  const { isLoading, error, isAuthenticated, user, handleRedirectCallback } = useAuth0();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  console.log('in Callback.js beginning the isAuthenticated = ', isAuthenticated)

  useEffect(() => {
    async function processCallback() {
      try {
        // This completes the Auth0 login redirect flow and restores app state
        console.log('Callback.js - Processing Auth0 callback');
        const { appState } = await handleRedirectCallback();
        // Dispatch your user profile with namespaced metadata to Redux
        dispatch(setProfile({
          email: user.email,
          name: user.name,
          sub: user.sub,
          picture: user.picture,
          nickname: user.nickname,
          app_metadata: user['https://thebrassstargroup.com/app_metadata'] || {},
          user_metadata: user['https://thebrassstargroup.com/user_metadata'] || {},
        }));
         // Navigate to the original page requested, or fallback to /dashboard
        navigate(appState?.returnTo || '/dashboard', { replace: true });
      } catch (err) {
        console.error('Callback.js - Error processing callback:', err);
        navigate('/error', { replace: true });
      }
    }

    // Check if URL has Auth0 redirect params (code and state)
  const params = new URLSearchParams(location.search);
  if (!params.has('code') || !params.has('state')) {
    console.log('Callback.js - No Auth0 redirect params, skipping callback processing');
    navigate('/dashboard', { replace: true });
    return;
  }
    // Only run when not loading and user is authenticated
    if (!isLoading && isAuthenticated && user) {
    processCallback();
    }
 }, [isLoading, isAuthenticated, user, handleRedirectCallback, dispatch, navigate]);

  if (isLoading) return <div>Loading in callback...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return <div>Redirecting.....</div>;
};

export default Callback;